<script setup lang="ts">
import { computed, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import { Product } from "../../types/TextDiffsTypes.ts";

const props = defineProps({
    visible: {
        type: Boolean,
        required: true,
    },
    selectedProduct: {
        type: Object as PropType<Product | null>,
        default: null,
    },
    selectedLanguage: {
        type: String as () => string | null,
        default: null,
    },
});

const emit = defineEmits(['update:visible', 'confirm', 'cancel']);

const { t } = useI18n();

const visibleModel = computed({
    get: () => props.visible,
    set: (value) => emit('update:visible', value)
});

function onConfirm() {
    emit('confirm');
}

function onCancel() {
    emit('cancel');
}
</script>

<template>
    <Dialog
        v-model:visible="visibleModel"
        modal
        :header="t('textDiffs.confirmRelease')"
        :style="{ width: '450px' }"
        data-cy="text-diffs_release-dialog"
    >
        <div class="confirmation-content" data-cy="text-diffs_confirmation-content">
            <i class="pi pi-exclamation-triangle confirmation-icon" data-cy="text-diffs_warning-icon"></i>
            <span data-cy="text-diffs_confirmation-message">{{
                    t('textDiffs.confirmReleaseMessage', {
                        product: selectedProduct?.value,
                        language: selectedLanguage
                    })
                }}</span>
        </div>
        <template #footer>
            <Button
                :label="t('buttons.cancel')"
                icon="pi pi-times"
                text
                @click="onCancel"
                data-cy="text-diffs_cancel-release-button"
            />
            <Button
                :label="t('textDiffs.releaseChanges')"
                icon="pi pi-upload"
                severity="success"
                @click="onConfirm"
                data-cy="text-diffs_confirm-release-button"
            />
        </template>
    </Dialog>
</template>

<style scoped>
.confirmation-content {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.confirmation-icon {
    font-size: 2rem;
    color: var(--p-orange-500);
}
</style>
